import { render, staticRenderFns } from "./GlobalLayout.vue?vue&type=template&id=f5ac4100"
import script from "./GlobalLayout.vue?vue&type=script&lang=js"
export * from "./GlobalLayout.vue?vue&type=script&lang=js"
import style0 from "./GlobalLayout.vue?vue&type=style&index=0&id=f5ac4100&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports